<template>
  <VaLayout class="login-auth-mobile h-screen relative">
    <template #content>
      <div class="fixed inset-0 z-0 bg-no-repeat" :style="brandBackgroundStyleMobile" aria-hidden="true" />
      <div class="relative z-10 min-h-screen flex flex-col p-4">
        <main class="flex flex-1 flex-col items-center justify-center w-full mx-auto max-w-[420px]">
          <div class="w-full rounded-lg bg-[var(--va-background-primary)] p-6 shadow-[0_8px_32px_rgba(0,0,0,0.12)]">
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

/** Imagen servida desde `public/images/` (copia de `images/Portal Empresarial.png`) */
const portalImageUrl = encodeURI('/images/Portal Empresarial.png')

/** Fondo móvil: misma lógica para que el logotipo no quede cortado al costado. */
const brandBackgroundStyleMobile = computed(() => ({
  backgroundImage: `url("${portalImageUrl}")`,
  backgroundSize: 'contain',
  backgroundPosition: 'center top',
  backgroundRepeat: 'no-repeat',
  backgroundColor: 'var(--va-background-secondary)',
}))
</script>
